'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.defineSchema = defineSchema;
exports.hasMany = hasMany;
exports.generateSchemas = generateSchemas;

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _normalizr = require('normalizr');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getRelatedThrough(entity1, entity2) {
  var entity1Schema = entity1.schema;
  var entity2Schema = entity2;
  var t = Object.keys(entity1Schema).find(function (prop) {
    if (prop.startsWith('_')) {
      return false;
    }
    var relation = entity1Schema[prop];
    if (relation.key) {
      return relation.key === entity2Schema.key;
    } else if (Array.isArray(relation)) {
      return relation[0].key === entity2Schema.key;
    }
    return false;
  });
  return t;
}

function createSchemaDefinition(config, bag) {
  var definition = Object.keys(config.attributes).reduce(function (memo, a) {
    var attribute = config.attributes[a];
    if (typeof attribute === 'function') {
      // Treat it like a computed property
      return _extends({}, memo, { _computed: _extends({}, memo._computed, _defineProperty({}, a, attribute)) });
    } else if (typeof attribute === 'string') {
      // Single reference to another schema
      return _extends({}, memo, _defineProperty({}, a, bag[attribute]));
    } else if (attribute.isArray) {
      // Array reference to another schema
      return _extends({}, memo, _defineProperty({}, a, [bag[attribute.relatedSchema]]));
    }
    return memo; // Should never come to here
  }, {});
  return _extends({}, definition, (0, _omit2.default)(config, 'attributes'));
}

function extractRelatedEntities(attributes) {
  return Object.keys(attributes).reduce(function (memo, a) {
    var attribute = attributes[a];
    if (typeof attribute === 'string') {
      // Single reference to another schema
      return [].concat(_toConsumableArray(memo), [{ prop: a, entity: attribute, isArray: false }]);
    } else if (attribute.isArray) {
      // Array reference to another schema
      return [].concat(_toConsumableArray(memo), [{ prop: a, entity: attribute.relatedSchema, isArray: true }]);
    }
    return memo;
  }, []);
}

function getRelations(schema, relatedEntities, bag) {
  return function () {
    return relatedEntities.map(function (relatedEntity) {
      return {
        to: relatedEntity.entity,
        through: relatedEntity.prop,
        foreign: getRelatedThrough(bag[relatedEntity.entity], schema),
        isMany: relatedEntity.isArray
      };
    });
  };
}

function generateSchema(schema, bag) {
  var finalSchema = bag[schema.name];
  finalSchema.define(createSchemaDefinition(schema.config, bag));

  Object.defineProperty(finalSchema, 'getRelations', {
    enumerable: false,
    value: getRelations(finalSchema, extractRelatedEntities(schema.config.attributes), bag)
  });

  return finalSchema;
}

function defineSchema(name) {
  var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if ((0, _isEmpty2.default)(name)) {
    throw new Error('[INVALID NAME]');
  }
  if ((typeof config === 'undefined' ? 'undefined' : _typeof(config)) !== 'object' && config) {
    throw new Error('[INVALID CONFIG]');
  }
  return {
    name: name,
    config: {
      attributes: config.attributes ? config.attributes : {},
      options: config.options ? config.attributes : {}
    }
  };
}

function hasMany(schema) {
  if ((0, _isEmpty2.default)(schema)) {
    throw new Error('[INVALID SCHEMA]');
  }
  if (typeof schema !== 'string' && !schema.hasOwnProperty('name')) {
    throw new Error('[INVALID SCHEMA]');
  }
  return {
    relatedSchema: schema.hasOwnProperty('name') ? schema.name : schema,
    isArray: true
  };
}

function generateSchemas(schemas) {
  if ((0, _isEmpty2.default)(schemas)) {
    throw new Error('[INVALID SCHEMAS]');
  }
  if (!Array.isArray(schemas)) {
    throw new Error('[INVALID SCHEMAS]');
  }
  var schemasBag = schemas.reduce(function (bag, s) {
    return _extends({}, bag, _defineProperty({}, s.name, new _normalizr.schema.Entity(s.name, {}, s.config.options)));
  }, {});
  var t = schemas.reduce(function (result, s) {
    return _extends({}, result, _defineProperty({}, s.name, generateSchema(s, schemasBag)));
  }, {});
  return t;
}